/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const whatsAppAiCriteriaDataSchema = z.object({
	mustHave: z.array(z.string()).default([]),
	niceToHave: z.array(z.string()).default([]),
})

export type WhatsAppAiCriteriaDataSchema = z.infer<typeof whatsAppAiCriteriaDataSchema>
